import React from "react";
import { useParams } from "react-router";
import CreateReportContainer from "../../containers/reports/CreateReport";

const CreateReportPage = () => {
  const { id } = useParams();
  return id ? (
    <CreateReportContainer reportId={id} />
  ) : (
    <CreateReportContainer />
  );
};

export default CreateReportPage;
